import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'
import { MachineOverview } from './machine'

export interface LineGroup {
  id: string
  groupName: string
  machines: MachineOverview[]
}

export interface AddMachineToGroup {
  id: string
  machines: string[]
}

export interface LineGroupStore {
  groups: LineGroup[]
}
export const lineStore: Module<LineGroupStore, {}> = {
  namespaced: true,
  state: () => ({
    groups: []
  }),
  mutations: {
    getAll(state, payload: LineGroup[]) {
      state.groups = payload
    }
  },
  actions: {
    async getAll({ commit }) {
      const { data } = await axios.get(`${BASE_API_URL}/line`)
      commit('getAll', data)
    },
    async addMachineToGroup({ dispatch }, { id, machines }: AddMachineToGroup) {
      const { data } = await axios.put(`${BASE_API_URL}/line/${id}`, machines)
      await dispatch('getAll')
      return data
    }
  },
  getters: {
    groups: state => state.groups
  }
}
